import React, { useRef } from 'react';
import './splash.css';
import technevideo from '../assets/glassvid.mp4';
import elogomask from '../assets/elogo.svg';
import logo from '../assets/logo.png';
import { Link } from 'react-router-dom';
import { useGsapAnimations } from '../hooks/useGsapAnimations';

const Splash = () => {
  const pageRef = useRef(null);

  useGsapAnimations(pageRef);

  return (
    <main className='splash_page' ref={pageRef}>
      <div className='splash_center' data-gsap-intro>

        <div
          className='e_video_mask'
          data-gsap-float
          style={{
            WebkitMaskImage: `url(${elogomask})`,
            maskImage: `url(${elogomask})`,
          }}
        >
          <video
            className='e_video' src={technevideo} autoPlay muted loop playsInline
          />
        </div>

      </div>

      <div className='splash_content' data-gsap-stagger="children" data-gsap-start="top 96%">
          <img src={logo} alt="Techne Logo" />
          <h1>Future Tech Experience <br /> Starts Here</h1>
          <Link className='btnstyle1' to="/onboarding">
            Get Started
          </Link>
      </div>
    </main>
  );
};

export default Splash;
